import { TipoVariavel } from "../../enum/tipo-variavel.enum";
import { IdNome } from "../id-nome.model";

export class Variavel {
  id?: number;
  nome?: string;
  tipo?: TipoVariavel | any;
  maxCaracteres?: number;
  minCaracteres?: number;
  ativo?: boolean;
  isPesquisa = false;

  usuarioCriacao?: IdNome;
  dataCriacao?: Date;
  usuarioAlteracao?: IdNome;
  dataAlteracao?: Date;
}
